exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input--phone .input-container{display:flex;align-items:center;border:1px solid #c9c9c9;border-radius:3px;padding:0 15px;height:60px}.input--phone .input-container input{border:0 !important;padding:15px 0 !important;min-height:auto !important;outline:none;height:100%}.input--phone .input-container .clear-button{cursor:pointer}.input--phone .input-container .clear-button span.icon{position:relative;top:2px}", ""]);

// exports
